import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { StoryAndLegacy } from './components/StoryAndLegacy';
import { FounderStory } from './components/FounderStory';
import { LeadershipTeam } from './components/LeadershipTeam';
import { BrandStory } from './components/BrandStory';
import { TrustedNetwork } from './components/TrustedNetwork';
import { ServicesSection } from './components/ServicesSection';
import { ThoughtLeadership } from './components/ThoughtLeadership';
import { HiddenMarket } from './components/HiddenMarket';
import { ProcessSection } from './components/ProcessSection';
import { SuccessStories } from './components/SuccessStories';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-sage-50 font-sans text-body" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <StoryAndLegacy data-id="element-4" />
        <LeadershipTeam data-id="element-5" />
        <BrandStory data-id="element-6" />
        <TrustedNetwork data-id="element-7" />
        <ServicesSection data-id="element-8" />
        <ThoughtLeadership data-id="element-9" />
        <HiddenMarket data-id="element-10" />
        <ProcessSection data-id="element-11" />
        <SuccessStories data-id="element-12" />
        <Testimonials data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}